import { render, staticRenderFns } from "./dragdrop-upload.vue?vue&type=template&id=3de22b8b&"
import script from "./dragdrop-upload.vue?vue&type=script&lang=js&"
export * from "./dragdrop-upload.vue?vue&type=script&lang=js&"
import style0 from "./dragdrop-upload.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VFabTransition } from 'vuetify/lib/components/transitions';
import { VFileInput } from 'vuetify/lib/components/VFileInput';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VFabTransition,VFileInput,VIcon})
